import React from 'react';
import { ContactFormProvider } from './components/contact/ContactForm';

const wrapRootElement = ({ element }) => <ContactFormProvider>{element}</ContactFormProvider>;
export default wrapRootElement;
